(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define("TenementMap", [
            'jquery',
            'leaflet'
        ], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(
            require('jquery'),
            require("leaflet")
        );
    } else {
        // Browser globals (root is window)
        root.returnExports = factory(root.main, root.leaflet);
    }
}(typeof self !== 'undefined' ? self : this, function ($, leaflet) {


    /**
     * Tenement map initialize
     *
     * @param options
     * @constructor
     */
    function TenementMap(options) {
        this.defaultsSM = {
            map: {
                minZoom: 3,
                maxZoom: 9,
                zoom: 3,
                zoomControl: false,
                dragging: false
            },
            diff: 10,
            overlayClassname: "image-overlay"
        };

        this.defaultsXL = {
            map: {
                minZoom: 5,
                maxZoom: 9,
                zoom: 5,
                zoomControl: false,
                dragging: false
            },
            diff: -5,
            overlayClassname: "image-overlay"
        };

        this.defaults = (window.innerWidth >= 768) ? this.defaultsXL : this.defaultsSM;

        this.$element = $("#" + options.tenementMapID);

        if ( this.$element.length ) {
            this.options = $.extend({}, this.defaults, options);

            this.setImageProperties();

            if ( window.innerWidth >= 1024 ) {
                this.options.diff = this.$element.height() / 1000;
            }

            let self = this;

            this.$element.on('init.tenement', function () {
                self.setImageBounds(self.options.image.width, self.options.image.height);
                self.init();
            });
        }
    }

    /**
     * Tenement functions
     *
     * @type {{init: init, getImageSrc: (function(): *), setImageProperties: setImageProperties, setImageBounds: setImageBounds, getImageBounds: (function(): *[])}}
     */
    TenementMap.prototype = {
        init: function () {
            let self = this;

            /**
             * Map options
             */
            let options = $.extend({}, this.options.map, {
                center: [(this.options.imageBounds.endY / 2), (this.options.imageBounds.endX / 2)],
                maxBounds: [this.getImageBounds()]
            });

            /**
             * Initializing map
             */
            this.map = L.map(this.options.tenementMapID, options);

            /**
             * Add image to map
             */
            this.overlay = L.imageOverlay(this.options.image.src, this.getImageBounds(), {
                className: "." + this.options.overlayClassname
            }).addTo(this.map);

            this.overlay.on('load', function () {
                let image = this._image;

                self.options.overlay = {
                    width: image.clientWidth,
                    height: image.clientHeight
                };
            });

            this.addZoomToMap();
            this.addResetToMap();
            this.addLegendToMap();
            this.addEventHandlers();
        },

        getImageSrc: function () {
            return this.$element.data("image");
        },

        setImageProperties: function () {
            let self = this;
            let img = new Image();
            img.src = this.getImageSrc();

            img.onload = function () {
                self.options.image = {
                    width: this.naturalWidth,
                    height: this.naturalHeight,
                    src: self.getImageSrc()
                };

                self.$element.trigger("init.tenement");
            };

            img.onerror = function (e) {
                console.error("A térkép nem található!");
            };
        },

        setImageBounds: function (width, height) {
            let t = 100;

            this.options.imageBounds = {
                startY: 0,
                startX: 0,
                endY: (height / t) + this.options.diff,
                endX: (width / t) + this.options.diff
            };
        },

        getImageBounds: function () {
            let startY = this.options.imageBounds.startY,
                startX = this.options.imageBounds.startX,
                endY = this.options.imageBounds.endY,
                endX = this.options.imageBounds.endX;

            return [[startY, startX], [endY, endX]];
        },

        getLegendLine: function (selector) {
            let line = document.createElement("div");
            line.className = selector + "-line";

            let icon = new Image();
            icon.src = this.$element.data(selector + "-icon");

            let text = document.createElement("p");
            text.innerText = this.$element.data(selector + "-text");

            line.appendChild(icon);
            line.appendChild(text);

            return line;
        },

        addResetToMap: function () {
            let control = new L.Control({position: "bottomleft"});
            control.onAdd = function (map) {
                let reset = L.DomUtil.create('a', 'map-reset');
                let icon = document.createElement("i");
                icon.classList.add("icon");
                icon.classList.add("icon-reset");
                reset.appendChild(icon);
                reset.href = "#";

                L.DomEvent.disableClickPropagation(reset).addListener(reset, "click", function (e) {
                    e.preventDefault();
                    map.setView(map.options.center, map.options.zoom);
                }, reset);

                return reset;
            };

            control.addTo(this.map);
        },

        addLegendToMap: function () {
            let legend = new L.Control({position: "bottomright"}),
                self = this;

            legend.onAdd = function (map) {
                let container = document.createElement("div");
                container.className = "legend-container";

                container.appendChild(self.getLegendLine("free"));
                container.appendChild(self.getLegendLine("busy"));

                return container;
            };

            legend.addTo(this.map);
        },

        addZoomToMap: function () {
            L.control.zoom({
                position: "bottomleft"
            }).addTo(this.map);
        },

        addEventHandlers: function () {
            let self = this;

            this.map.on('zoomend', function (e) {
                let currentZoomLevel = e.target._zoom,
                    minZoomLevel = self.options.map.minZoom;

                if ( currentZoomLevel > minZoomLevel ) {
                    self.map.dragging.enable();
                } else {
                    self.map.dragging.disable();
                }
            });
        }
    };

    return TenementMap;

}));


//////////////////
// WEBPACK FOOTER
// ./js/modules/tenementMap/index.js
// module id = 16
// module chunks = 1